export default __webpack_public_path__ + "static/koi-aerial-waterfall-a9648c42bbbc557ba8ab7b6e26eae341.webp";